export default __webpack_public_path__ + "audios/ea0f5342c453abfccbdc07c20dea8d6c.mp3";